import { Injectable } from '@angular/core';
import { UserfirestoreService } from 'src/app/auth/fire-store/userfirestore.service';
import { AngularFireStorage } from '@angular/fire/storage';
import 'firebase/storage';
import { ImageCroppedEvent } from 'ngx-image-cropper';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  imageChangedEvent: any = '';
  croppedImage: any = '';
  pictureURL: any = '';

  constructor(
    private userService: UserfirestoreService,
    private angularFireStorage: AngularFireStorage
  ) {}

  updatePhoto(uid: string): Promise<any> {
    if (this.croppedImage) {
      const currentPictureId = Date.now();
      const refPicture = this.angularFireStorage
        .ref(`pictures/${currentPictureId}.jpg`)
        .putString(this.croppedImage, 'data_url');
      //The image is in base64 => binary
      refPicture
        .then((result) => {
          this.pictureURL = this.angularFireStorage
            .ref(`pictures/${currentPictureId}.jpg`)
            .getDownloadURL();

          /************ */
          this.pictureURL.subscribe((p) => {
            this.userService
              .setAvatar(p, uid)
              .then(() => {
                alert('Avatar succesfully uploaded');
                return Promise.resolve();
              })
              .catch((error) => {
                alert('Something went wrong when uploading your avatar');
                console.log(error);
                return Promise.reject();
              });
          });
        })
        .catch(() => Promise.reject());
    }
    return Promise.reject();
  }

  fileChangeEvent(event: any): void {
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.croppedImage = event.base64;
  }
  imageLoaded() {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }
}
